export const environment = {
  production: false,
  incompletePickingApiUrl: 'https://knowledge-dev.cc.cloudintercorpretail.pe',
  incompletePickingApiAuth: 'Basic YWRtaW46Y3VzdG9tZXJDYXJlLjIwMjA='
};
